import { useState } from "react";
import { CampoNumero, Resultado, Dato, Rejilla, mxn } from "../components/campos.jsx";
import { calcularViaje } from "../lib/calc.js";

export default function Viaje() {
  const [distancia, setDistancia] = useState(400);
  const [rendimiento, setRendimiento] = useState(14);
  const [precio, setPrecio] = useState(24);
  const [casetas, setCasetas] = useState(500);
  const [pasajeros, setPasajeros] = useState(4);
  const [idaYVuelta, setIdaYVuelta] = useState(false);

  const r = calcularViaje({
    distanciaKm: distancia,
    rendimientoKmPorLitro: rendimiento,
    precioLitro: precio,
    casetas,
    pasajeros,
    idaYVuelta,
  });

  return (
    <div className="space-y-6">
      <Rejilla>
        <div className="space-y-4">
          <CampoNumero label="Distancia total de ruta" valor={distancia} onChange={setDistancia} sufijo="km" min={0} />
          <CampoNumero
            label="Rendimiento del vehículo"
            valor={rendimiento}
            onChange={setRendimiento}
            sufijo="km/L"
            min={0}
            ayuda="Referencia: compacto ~14, SUV ~10, pickup ~8."
          />
          <CampoNumero label="Gasolina" valor={precio} onChange={setPrecio} prefijo="$" sufijo="/L" min={0} />
          <CampoNumero label="Casetas / peajes" valor={casetas} onChange={setCasetas} prefijo="$" min={0} />
          <CampoNumero label="Pasajeros" valor={pasajeros} onChange={setPasajeros} min={1} step="1" />

          <label className="flex cursor-pointer items-center gap-2 text-sm texto-2">
            <input
              type="checkbox"
              checked={idaYVuelta}
              onChange={(e) => setIdaYVuelta(e.target.checked)}
              className="h-4 w-4 rounded borde superficie-2 acento"
            />
            Calcular ida y vuelta
          </label>
        </div>

        <div className="order-first space-y-3 lg:order-last lg:col-span-2">
          <Resultado label="Costo total del viaje" valor={mxn(r.total)} nota={`${r.distancia.toLocaleString("es-MX")} km recorridos`} />
          <Resultado label="Por pasajero" valor={mxn(r.porPasajero)} tono="positivo" nota={`Entre ${Math.max(1, Math.round(pasajeros))} personas`} />

          <div className="tarjeta">
            <Dato label="Litros de gasolina necesarios" valor={`${r.litros.toFixed(1)} L`} />
            <Dato label="Costo de combustible" valor={mxn(r.combustible)} />
            <Dato label="Casetas" valor={mxn(r.peajes)} />
            <Dato label="Total" valor={mxn(r.total)} destacar />
          </div>
        </div>
      </Rejilla>
    </div>
  );
}
